export default "__VITE_ASSET__DLMofOj2__"